const facetName = (facet, val, extra = null) => {
	if(extra) {
		if(extra == 'sort') {
			return jQuery('.c-quicknav__content .facetwp-sort input[value="' + val + '"]').next('label').text();
		} else if (extra == 'proximity') {
      return decodeURIComponent(FWP.facets[facet][3]) +' | '+ FWP.facets[facet][2] + 'km';
    }
	}

	return jQuery('.facetwp-facet[data-name="' + facet + '"] [data-value="' + val + '"]').data('name');

};

export default facetName;
